// Keys are translated from enUS
export * from "./arSD.js";
export * from "./beBY.js";
export * from "./bgBG.js";
export * from "./bnBD.js";
export * from "./csCZ.js";
export * from "./caES.js";
export * from "./daDK.js";
export * from "./deDE.js";
export * from "./elGR.js";
export * from "./enUS.js";
export * from "./esES.js";
export * from "./faIR.js";
export * from "./fiFI.js";
export * from "./frFR.js";
export * from "./heIL.js";
export * from "./huHU.js";
export * from "./hyAM.js";
export * from "./itIT.js";
export * from "./jaJP.js";
export * from "./koKR.js";
export * from "./nbNO.js";
export * from "./nlNL.js";
export * from "./nnNO.js";
export * from "./plPL.js";
export * from "./ptBR.js";
export * from "./roRO.js";
export * from "./ruRU.js";
export * from "./skSK.js";
export * from "./svSE.js";
export * from "./trTR.js";
export * from "./ukUA.js";
export * from "./urPK.js";
export * from "./viVN.js";
export * from "./zhCN.js";
export * from "./zhTW.js";
export * from "./hrHR.js";
export * from "./ptPT.js";
export * from "./zhHK.js";
export * from "./isIS.js";
export * from "./idID.js";